// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-f91805ce] {\n  position: relative;\n  top: -70px;\n}\n[data-v-f91805ce] .el-dialog__header,[data-v-f91805ce] .el-dialog__footer {\n  border: none;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
